import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Market } from '../../types';

const initialState = {
  isMarketScreen: false,
  market: {} as Market,
  markets: [] as Market[],
};

const marketsSlice = createSlice({
  name: 'markets',
  initialState,
  reducers: {
    setMarket: (state, action: PayloadAction<Market>) => {
      state.market = action.payload;
      const updatedMarket = action.payload;
      const index = state.markets.findIndex((campaign) => campaign.id === updatedMarket.id);

      if (index !== -1) {
        state.markets[index] = updatedMarket;
      } else {
        state.markets.push(updatedMarket);
      }
    },
    setMarkets: (state, action: PayloadAction<Market[]>) => {
      state.markets = action.payload;
    },
    setIsMarketScreen: (state, action: PayloadAction<boolean>) => {
      state.isMarketScreen = action.payload;
    },
  },
});

export const { setMarket, setMarkets, setIsMarketScreen } = marketsSlice.actions;

export default marketsSlice.reducer;
